import { createApp } from 'vue'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import router from './router'
import WebView from 'vue-webview'

// 引入vant组件样式
import 'vant/lib/index.css';
// 引入移动端适配
// import 'lib-flexible/flexible.js'
import VueWechatTitle from 'vue-wechat-title'//动态修改title

// var prefix = 'hapsee'
// var suffix = 'cn'
var prefix = 'birds'
var suffix = 'cn'
// var prefix = 'keepeyes'
// var suffix = 'cn'

// var prefix = 'help'
// var suffix = 'cn'
router.beforeEach((to, from, next) => {
    if (to.path == '/first') {
        if (to.query.appkey != undefined) {
            if (to.query.appkey.toLocaleLowerCase() == "com.dayunlinks.cloudbirds") {
                prefix = 'birds'
            } else if (to.query.appkey.toLocaleLowerCase() == "com.dayunlinks.hapseemate") {
                prefix = 'hapsee'
            } else if (to.query.appkey.toLocaleLowerCase() == "com.fnkiot.junan") {
                prefix = 'junan'
            } else {
                prefix = 'keepeyes'
            }
        }
        if (to.query.lang != undefined) {
            if (to.query.lang.toLocaleLowerCase().includes("zh") || to.query.lang.toLocaleLowerCase().includes("ch") || to.query.lang.toLocaleLowerCase().includes("cn")) {
                suffix = 'cn'
            } else if (to.query.lang.toLocaleLowerCase().includes("ru")) {
                suffix = 'ru'
            } else {
                suffix = 'en'
            }
        }
        next({
            path: "/dist/lang/index",
            query: {
                id: prefix + '-' + suffix
            }
        })
    } else {
        prefix = 'help'

        if (to.query.lang && to.query.lang != undefined) {
            if (to.query.lang.toLocaleLowerCase().includes("zh") || to.query.lang.toLocaleLowerCase().includes("ch") || to.query.lang.toLocaleLowerCase().includes("cn")) {
                suffix = 'cn'
            } else if (to.query.lang.toLocaleLowerCase().includes("ru")) {
                suffix = 'ru'
            } else {
                suffix = 'en'

            }
        } else {
            let lang = new URLSearchParams(window.parent.location.search).get('lang')
            if (!lang) {
                suffix = 'cn'
            } else if (lang.toLocaleLowerCase().includes("zh") || lang.toLocaleLowerCase().includes("ch") || lang.toLocaleLowerCase().includes("cn")) {
                suffix = 'cn'
            } else if (lang.toLocaleLowerCase().includes("ru")) {
                suffix = 'ru'
            } else {
                suffix = 'en'

            }
        }
    }
    console.log(`output->to.query`, suffix)
    // console.log(`output->i18n`, i18n.global,  to.meta, i18n.global.t(`help.${to.meta.title}`))
    if ((to.path == '/dist/cloudSee/problem' || to.path == '/dist/cloudSee/problemDetail') && to.query && to.query.value) {
        let value = JSON.parse(to.query.value)
        console.log(`output->to.query`, value.oneTitle)
        to.meta.title = value.oneTitle
        document.title = value.oneTitle
    } else {
        if (to.meta && to.meta.title) {
            // window.parent.document.title = i18n.global.messages[prefix + '-' + suffix].help[to.meta.title] // 动态设置页面标题
            if (window.frameElement) {
                let parentTitle = window.parent.document.title
                if (/^[A-Za-z,.'-]+$/.test(parentTitle)) {
                    let title = i18n.global.messages[prefix + '-' + suffix].help[parentTitle]
                    window.parent.document.title = title ? title : parentTitle
                    document.title = title ? title : parentTitle
                } else {
                    window.parent.document.title = parentTitle
                    document.title = parentTitle
                }
            } else {
                document.title = i18n.global.messages[prefix + '-' + suffix].help[to.meta.title] // 动态设置页面标题
            }

        }
    }
    // else {
    //     let parentTitle = window.parent.document.title
    //     console.log(`/^[A-Za-z,.'-]+$/`, /^[A-Za-z,.'-]+$/.test(parentTitle))
    //     if (/^[A-Za-z,.'-]+$/.test(parentTitle)) {
    //         let title = i18n.global.messages[prefix + '-' + suffix].help[parentTitle]
    //         console.log(`prefix + '-' + suffix->`, prefix + '-' + suffix, 'title', title)
    //         window.parent.document.title = title ? title : parentTitle
    //     } else {
    //         window.parent.document.title = parentTitle
    //     }
    // }
    next()
})


// 通过选项创建 VueI18n 实例
const i18n = new createI18n({
    locale: prefix + '-' + suffix, // 设置地区
    messages: {
        'birds-cn': require('@/common/language/cn/birds'),
        'birds-en': require('@/common/language/en/birds'),
        'birds-ru': require('@/common/language/ru/birds'),
        'hapsee-cn': require('@/common/language/cn/hapsee'),
        'hapsee-en': require('@/common/language/en/hapsee'),
        'hapsee-ru': require('@/common/language/ru/hapsee'),
        'keepeyes-cn': require('@/common/language/cn/keepeyes'),
        'keepeyes-en': require('@/common/language/en/keepeyes'),
        'keepeyes-ru': require('@/common/language/ru/keepeyes'),
        'junan-cn': require('@/common/language/cn/junan'),
        'junan-en': require('@/common/language/en/junan'),
        'junan-ru': require('@/common/language/ru/junan'),
        'cancellation-cn': require('@/common/language/cn/cancellation'),
        'cancellation-en': require('@/common/language/en/cancellation'),
        'cancellation-ru': require('@/common/language/ru/cancellation'),
        'help-cn': require('@/common/language/cn/help'),
        'help-en': require('@/common/language/en/helpEn'),
        'help-ru': require('@/common/language/ru/helpRu'),
        'recharge-cn': require('@/common/language/cn/recharge'),
        'recharge-en': require('@/common/language/en/recharge'),
        'recharge-ru': require('@/common/language/ru/recharge'),
        'infoList-cn': require('@/common/language/cn/infoList'),
        'infoList-en': require('@/common/language/en/infoList'),
        'infoList-ru': require('@/common/language/ru/infoList'),
    }, // 设置地区信息
})

const app = createApp(App)
app.use(router)
app.use(i18n)
app.use(WebView)
app.use(VueWechatTitle)
app.mount('#app');